export const headgearoptions = [
	{ value: 'Aviator', label: 'Aviator', parm: 'headgear' },
	{ value: 'Black Beanie', label: 'Black Beanie', parm: 'headgear' },
	{ value: 'Black Cap', label: 'Black Cap', parm: 'headgear' },
	{ value: 'Blue Beanie', label: 'Blue Beanie', parm: 'headgear' },
	{ value: 'Blue Flame', label: 'Blue Flame', parm: 'headgear' },
	{ value: 'Blue Hair', label: 'Blue Hair', parm: 'headgear' },
	{ value: 'Chef Hat', label: 'Chef Hat', parm: 'headgear' },
	{ value: 'Crown', label: 'Crown', parm: 'headgear' },
	{ value: 'Fire', label: 'Fire', parm: 'headgear' },
	{ value: 'Gold Hat', label: 'Gold Hat', parm: 'headgear' },
	{ value: 'Halo', label: 'Halo', parm: 'headgear' },
	{ value: 'Headset', label: 'Headset', parm: 'headgear' },
	{ value: 'Helmet', label: 'Helmet', parm: 'headgear' },
	{ value: 'Hoodie', label: 'Hoodie', parm: 'headgear' },
	{ value: 'Newsie', label: 'Newsie', parm: 'headgear' },
	{ value: 'Pirate Hat', label: 'Pirate Hat', parm: 'headgear' },
	{ value: 'Purple Beanie', label: 'Purple Beanie', parm: 'headgear' },
	{ value: 'Red Beanie', label: 'Red Beanie', parm: 'headgear' },
	{ value: 'Top Hat', label: 'Top Hat', parm: 'headgear' },
	{ value: 'Tota Cap', label: 'Tota Cap', parm: 'headgear' },
	{ value: 'Tribe Hair', label: 'Tribe Hair', parm: 'headgear' },
	{ value: 'Updo', label: 'Updo', parm: 'headgear' },
	{ value: 'Viking Helmet', label: 'Viking Helmet', parm: 'headgear' },
];